import { Component } from '@angular/core';

import { PlanModel } from '@shared/models/plan.model';

import { DialogContent } from '@shared/components/dialog/dialog.component';

export interface UpgradePlanContentData {
    plan: PlanModel,
    billingFrequency: 'monthly' | 'annually'
}

@Component({
    selector: 'sfx-billing-settings-upgrade-plan-content',
    template: `
        <h3>
            <span [translate]="'You are about to upgrade your subscription to the {{planName}} plan'" [translateParams]="{planName: planName}">You are about to upgrade your subscription to the {{planName}} plan</span> <span class="sf-emoji">🎉</span>
        </h3>

        <div class="text">
            <p translate>
                You will gain access to the following features:
            </p>
            <div class="list-container">
                <ul>
                    <li *ngFor="let feature of plan.features">
                        {{ feature.name }}
                    </li>
                </ul>
            </div>
            <p translate>
                Your subscription will be updated and any differences will be billed pro rata
                <span *ngIf="billingFrequency === 'annually'">
                    at the start of next month
                </span>.
            </p>
        </div>
    `
})
export class UpgradePlanContentComponent implements DialogContent<UpgradePlanContentData> {

    public valid: true;

    public plan: PlanModel;
    public planName: string;

    public billingFrequency: 'monthly' | 'annually';

    constructor(
    ) {}

    setInitialState(context: UpgradePlanContentData): void {

        this.plan = context.plan;
        this.planName = context.plan.name;
        this.billingFrequency = context.billingFrequency;
    }

    getCurrentState(): UpgradePlanContentData {

        return { plan: this.plan, billingFrequency: this.billingFrequency };
    }
}
